module.exports = __webpack_public_path__ + "static/media/empties.816619b3.svg";